<template>
  <div class="vld-parent">
 

    <div class="d-none d-md-block">
      <l-map
        ref="map"
        :zoom="5"
        :center="center"
        style="height: 100vh"
        :options="{ zoomControl: false }"
      >
        <l-tile-layer
          :url="url"
          :attribution="attribution"
        ></l-tile-layer>

        <l-circle
          v-for="site in sites"
          :key="site.id"
          :lat-lng="[site.lat, site.lng]"
          :color="circlesites.color"
          :radius="circlesites.radius"
        >
          <l-popup>
            {{ site }}
          </l-popup>
        </l-circle>

        <l-circle
          v-for="ais in aisData"
          :key="ais.id"
          :lat-lng="[ais.lat, ais.lng]"
          :color="circleais.color"
          :radius="circleais.radius"
        >
          <l-popup>
            {{ ais }}
          </l-popup>
        </l-circle>

        <l-control-zoom position="topright"></l-control-zoom>

        <l-control :position="'topleft'">
          <!-- <b-card class="h-scroll m-2 min-width">
            <h3>Logg</h3>
            <hr />
            <vue-json-pretty :data="messages"> </vue-json-pretty>
          </b-card> -->
        </l-control>
      </l-map>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";
import VueMoment from "vue-moment";
import moment from "moment";





import "leaflet/dist/leaflet.css";

import { Icon } from "leaflet";
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

import {
  LMap,
  LTileLayer,
  LMarker,
  LControlLayers,
  LControl,
  LPopup,
  LCircle,
  LPolyline,
  LLayerGroup,
  LTooltip,
  LControlZoom,
  LControlAttribution,
  LControlScale,
} from "vue2-leaflet";

export default {
  components: {
 
    Datepicker,
    VueMoment,
    moment,
    LMap,
    LTileLayer,
    LMarker,
    LControlLayers,
    LControl,
    LPopup,
    LCircle,
    LPolyline,
    LLayerGroup,
    LTooltip,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      aisData: [],
      sites: [],
      zoom: 5,
      url:
        "https://api.mapbox.com/styles/v1/packtracker-com/ck8d9hr3y1adz1io2kctelu2y/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGFja3RyYWNrZXItY29tIiwiYSI6ImNrOGM1ZWYwZTBmdjAzZWthNTFjdXA1c3cifQ.V_peofXp-4LxUrosRdD9jA",
      attribution: '<a href="https://www.aquaservices.no">Aquaservices</a> ',
      center: L.latLng(65.355, 14.7487),
      circleais: {
        radius: 1,
        color: "#d40000",
      },
      circlesites: {
        radius: 1,
        color: "#0c3b49",
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sumMessagesTotal() {
      return this.messages.length;
    },
  },
  methods: {
    getAIS() {
      this.isLoading = true;
      axios.get("https://api.eines-as.no/ais?_limit=-1").then((res) => {
        this.aisData = res.data;
        this.isLoading = false;
      });
    },
    getSites() {
      //this.isLoading = true;
      axios
        .get("https://api.eines-as.no/sites?_limit=-1")
        .then((res) => {
          this.sites = res.data;
          // this.isLoading = false;
        });
    },
    updateMessages() {
      axios.get("https://api.eines-as.no/messages").then((res) => {
        this.messages = res.data;
      });
    },
  },
  created: function () {
    this.getAIS();
    this.getSites();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

.h-scroll {
  height: 95vh;
  /* %-height of the viewport */
  overflow: none !important;
  max-width: 500px;
}

.min-width {
  min-width: 415px;
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}
</style>